module.exports = __webpack_public_path__ + "img/feature-more.030ff753.svg";